
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const TechnicalConsultancyPage = lazy(() => import('../pages/technical-consultancy/page'));
const FoodJobsPage = lazy(() => import('../pages/food-jobs/page'));
const B2BSalesPage = lazy(() => import('../pages/b2b-sales/page'));
const SafetyAuditPage = lazy(() => import('../pages/safety-audit/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/technical-consultancy',
    element: <TechnicalConsultancyPage />,
  },
  {
    path: '/food-jobs',
    element: <FoodJobsPage />,
  },
  {
    path: '/b2b-sales',
    element: <B2BSalesPage />,
  },
  {
    path: '/safety-audit',
    element: <SafetyAuditPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
